import React, {
  useContext
} from 'react';

import {
  Text, HorizontalLine
} from './../../../StyledComponents';

import {
  SalesContext
} from '../../../Context/SalesContext';

import {
  isMobileView
} from '../../../Utility/utility';

import GreyPromotionIcon from '../../Common/Svg/GreyPromotionIcon';

import RemovePopup from '../RemovePopup/RemovePopup';

import './PackageTab.css';

export default (props) => {

  const context = useContext(SalesContext);

  const {
    setSelectedAdditionalServices
  } = context;

  const [ isRemove, setIsRemove ] = React.useState(false);
  const [ currentItem, setCurrentItem ] = React.useState(null);

  const getSinglePackageData = (data) => {

    function getDiscountString() {
      let discount = parseFloat(context.selectedPackage.productPrice.value) - parseFloat(context.selectedPackage?.discountAmount);
      let price = discount === 0 ? 'FREE' : `Only pay R${ discount } for the first`;

      return (`${ price } ${ context?.selectedPackage?.discountTerm }`);
    }

    return (

      <React.Fragment>
        <div
          className="sales-review-order__package-img"
        >
          <img
            src={data.imageUrl}
          />
        </div>

        <div
          className="sales-review-order__package-title-wrapper"
        >
          {context.selectedPackage.onDiscount

            ? <div className='plan-details-summary-discount-tag review-order-discount-tag'>On promotion</div>
            : null
          }

          {
            data.speed &&
            <Text
              fontSize="16px"
              color="#666"
              fontWeight="700"
            >
              {data.type === 'lte' ? data.speed : data.type}
            </Text>
          }

          { data.contractTerm &&
            <Text
              lineheight="2.5"
              fontWeight="400"
              fontSize="14px"
              color="#85858C"
            >
              Contract term: {data.contractTerm}
            </Text>
          }

          { context.selectedPackage.onDiscount && !isMobileView() &&

            <p className='generic-discount-container'>
              <GreyPromotionIcon
                marginRight='7px'
              />
              <Text
                lineheight="0"
                fontWeight="400"
                fontSize="14px"
                color="#85858C"
              >
                Promotion:
              </Text>

              <Text
                lineheight="0"
                fontWeight="700"
                fontSize="14px"
                color="#9C2AA0"
                paddingLeft="5px"
              >
                {getDiscountString()}
              </Text>
            </p>
          }

          { data.title &&
            <Text
              lineheight="2.2"
              fontWeight="700"
            >
              {data.title}
            </Text>
          }

          { data.description &&
            <Text
              fontSize="14px"
              color="#666"
            >
              {data.description}
            </Text>
          }

        </div>

        {
          !isMobileView() &&
          <Text
            style={{ marginLeft: 'auto' }}
          >
            <span
              style={{ fontWeight: 'bold' }}
            >
              {data.price}
              {data.contractTerm === '12 Months'
                ? 'x 12'
                : data.contractTerm === '24 Months'
                  ? 'x 24'
                  : ''
              }

            </span>
          </Text>
        }
      </React.Fragment>

    );
  };

  const handleRemove = (service, value) => {
    setSelectedAdditionalServices({ key: service.vasCategory, value: value });
    hideRemovePopup();
    // if (value) {
    //   console.log('value', value, 'service', service);
    //   additionalServiceTagger(service);
    // }
  };

  const additionalServicesObj = {
    'superWifi': 'WiFi extender',
    'voiceLine': 'voice'
  };

  const showRemovePopup = (item) => {
    setCurrentItem(item);
    setIsRemove(true);
  };

  const hideRemovePopup = () => {
    setIsRemove(false);
  };

  let packageData = null;

  if (props.data.length && props.data.length !== 0) {

    packageData = props.data.map((item, index) => {

      const hrLine =
        index !== props.data.length - 1
          ? <HorizontalLine />
          : null;

      return (

        <React.Fragment key={`fragment_${ index }`}>
          <div
            className="sales-review-order__package sales-review-order__package-additional"
            key={item.vasCategory}
          >
            {
              getSinglePackageData({
                imageUrl: item.imageUrl,
                type: item.vasCategory,
                speed: item.promotion,
                price: item.priceDescription,
                description: item.description,
                title: item.acronym || item.displayName
              })
              // getSinglePackageData({
              //   imageUrl: item.serviceUrl,
              //   type: item.serviceKey,
              //   speed: item.promotion,
              //   price: item.priceDescription,
              //   description: item.description,
              //   title: item.acronym
              // })
            }
          </div>
          {/* {
            !props.hideTrash ?
              <div style={{ paddingBottom: "1em" }}>
                <button onClick={showRemovePopup.bind(this, item)} className="remove-btn" automationid={`SalesLeads_button_removeButton_${index}`}>
                  <Trash className="trash" />
                  <span className="remove">Remove</span>
                </button>
              </div>
              :
              null
          } */}
          {hrLine}
          {
            isRemove ?
              <RemovePopup
                close={hideRemovePopup}
                onClick={handleRemove.bind(this, currentItem, false)}
                text={`You are about to remove the additional ${ additionalServicesObj[currentItem.vasCategory] } option from your order.`}
              >
              </RemovePopup>
              :
              null
          }
        </React.Fragment>
      );
    });
  } else {
    packageData = (
      <div
        className="sales-review-order__package-wrapper">
        {getSinglePackageData(props.data)}
      </div>
    );
  }

  return packageData;
};
